// extracted by mini-css-extract-plugin
export default {"label":"WPDiD","chat":"A5l9l","stream":"Ex994"};